import { Link } from "wouter";
import { spendStatusCopy } from "../lib/data";

/**
 * Callout when the latest payout window skipped because fees were too low.
 */
export default function SpendStatusBanner({ data, className = "" }) {
  const spend = data?.spend;
  const schedule = data?.schedule || {};
  const status = spendStatusCopy(spend, schedule);
  if (!status.waiting) return null;

  const when = spend?.lastAttempt?.at || spend?.at;

  return (
    <aside className={`spend-status ${className}`.trim()} role="status">
      <div className="spend-status__head">
        <span className="spend-status__pill">Paused</span>
        <strong>{status.title}</strong>
        {when ? (
          <time dateTime={when} className="spend-status__when mono">
            {new Date(when).toLocaleString(undefined, {
              dateStyle: "medium",
              timeStyle: "short",
            })}
          </time>
        ) : null}
      </div>
      <p>{status.detail}</p>
      <p className="spend-status__links">
        <Link href="/cycles">See cycles</Link>
        {" · "}
        <Link href="/faq">Why windows skip</Link>
      </p>
    </aside>
  );
}
